// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"212":"component---src-pages-landing-page-ghost-jsx","279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"212":"de93adc140982770b9de","279":"d69a8d75fb18dfeedfcc","415":"526e5d4c4412d7409080","577":"3de013b1737dc9b535f1"}[chunkId] + ".js";
};